export const collectPathsFromContent = (obj, paths = []) => {
    if (!obj) return paths;

    if (typeof obj === 'object' && obj.path) {
        paths.push({path: obj.path});
    }

    if (typeof obj === 'object' && obj.thumbnailPath) {
        paths.push({path: obj.thumbnailPath});
    }

    if (Array.isArray(obj)) {
        obj.forEach((item) => {
            collectPathsFromContent(item, paths);
        });
    } else if (typeof obj === 'object') {
        for (const value of Object.values(obj)) {
            collectPathsFromContent(value, paths);
        }
    }

    return paths;
};
